import { Button } from 'foundations-components/transitional/components/Button';
import { withClickTracking } from './withClickTracking';
export const TrackedButton = withClickTracking(Button);